import React from 'react';

const ContactBannerSolid = () => {
    return (
        <div className=' bg-[#F8F3FF] pt-28 pb-10'>
            <h2 className=' font-bold text-[#0B1B28] text-[48px]'>Contact Us</h2>
            <p className='text-[14px] text-[#0B1B28]'>If you have any query please let us know</p>
        </div>
    );
};

export default ContactBannerSolid;